import { render } from "./ContentHeader.vue?vue&type=template&id=2af04e15"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=2af04e15&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__